module.exports = __webpack_public_path__ + "images/referenzen/werbespot/issana_coconut_cremedusche.jpg";